<template>
  <div class="bg">
    <div class="wrapper">

      <worker-filter style="z-index: 100" v-on:gradeSelect="getAttendanceList"></worker-filter>

      <div class="attendance">
        <div class="list">
          <ul v-if="courseList.length > 0">
            <li v-for="course,index in courseList" :key="index">
              <attendance-item :course="course"></attendance-item>
            </li>
          </ul>
          <p v-else> 没有数据 </p>
        </div>
      </div>

      <div class="title">
      </div>

      <div class="back-box">
        <v-go-back-btn></v-go-back-btn>
      </div>
    </div>
  </div>

</template>

<script>
  import WorkerFilter from '../components/WorkerFilter.vue';
  import VGoBackBtn from '../components/VGoBackBtn.vue';
  import AttendanceItem from '../components/AttendanceItem.vue';
  import Teacher from '../api/teacher';
  import { mapGetters } from 'vuex';
  import { Toast, Indicator } from 'mint-ui';
  export default{
    name: 'attendance',
    created() {
      this.getAttendanceList();
    },
    destroy() {
      this.$destroy();
    },
    data() {
      return {
        courseList:[
        {
          course_title:'python',
          absenteeism_count:2,
          created_at:new Date().toLocaleString(),
          absence_user:[
            {
              id:1,
              username:'张三'
            },
            {
              id:2,
              username:'李四'
            }
          ]
        },
        {
          course_title:'c++',
          absenteeism_count:1,
          created_at:new Date().toLocaleString(),
          absence_user:[
            {
              id:1,
              username:'王五'
            },
          ]
        }
      ]
      };
    },
    methods: {
      getAttendanceList() {
      //   Indicator.open({text: '获取中...', spinnerType: 'fading-circle'});
      //   Teacher.getAttendanceList({
      //     school_id: this.school.school_id,
      //     grade_id: this.grade.grade_id
      //   }).then(response => {
      //     Indicator.close();
      //     if (response.errno === '0') {
      //       this.courseList = response.result;
      //     } else {
      //       Toast({message: '获取数据失败', position: 'middle', duration: 3000});
      //     }
      //   }).catch(e => {
      //     console.log(e);
      //   });
      }
    },
    components: {
      WorkerFilter,
      VGoBackBtn,
      AttendanceItem,
      Indicator,
      Toast
    },
    computed: {
      ...mapGetters({
        school: 'school',
        grade: 'grade'
      })
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .bg {
    @include bg-img('../assets/img/common/Bg');
    width: 100%;
  }

  .wrapper {
    padding-top: px2rem(48);
    width: 100%;
    .attendance {
      position: absolute;
      left: px2rem(23);
      top: px2rem(200);
      @include bg-img('../assets/img/common/parentbgbase');
      width: px2rem(704);
      height: px2rem(1004);
      .list {
        position: relative;
        height: px2rem(860);
        top: px2rem(90);
        width: 90%;
        margin: 0 auto;
        -webkit-overflow-scrolling: touch;
        overflow-y: scroll;
        overflow-x: hidden;
        p {
          padding-top: px2rem(50);
          font-size:  px2rem(30);
          text-align: center;
        }
      }
    }

    .title {
      position: absolute;
      width: px2rem(430);
      left: px2rem(160);
      top: px2rem(150);
      height: px2rem(114);
      @include bg-img('../assets/img/teacher/attendance');
    }

    .back-box {
      position: absolute;
      bottom: px2rem(80);
    }
  }
</style>



// WEBPACK FOOTER //
// Attendance.vue?74502fa6